import { useParams } from 'react-router-dom';
import BookingsPanel from '../../../components/BookingsPanel';

export default function BookingsRoute() {
  const { botId } = useParams<{ botId: string }>();
  if (!botId) return null;
  return <BookingsPanel botId={botId} />;
}
